import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {StandardName} from "../../store/state/order.state";
import {EndpointsProvider} from "../../umbrella-common/endpoints/endpoint-provider.service";

@Injectable()
export class StandardConfigurationsResolver implements Resolve<Observable<StandardConfiguration[]>> {

	constructor(private endpoints: EndpointsProvider) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<StandardConfiguration[]> {
		return this.endpoints.common.getStandards();
	}
}

export interface StandardConfiguration {
	standard: StandardName;
	availableWith: StandardName[];
}
